import React from 'react';
import { Routes, Route } from "react-router-dom";

// Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

// Routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import Error404 from "../admin/components/error404";
import { AuthProtected } from './AuthProtected';

const Index = () => {
    return (
        <React.Fragment>
            <Routes>
                {/* Public Routes */}
                {publicRoutes.map((route, idx) => (
                    <Route
                        path={route.path}
                        element={
                            <NonAuthLayout>
                                {route.component}
                            </NonAuthLayout>
                        }
                        key={idx}
                    />
                ))}

                {/* Auth Protected Routes */}
                {authProtectedRoutes.map((route, idx) => (
                    <Route
                        key={idx}
                        path={route.path}
                        element={
                            <AuthProtected allowedRoles={route.allowedRoles}>
                                <VerticalLayout>{route.component}</VerticalLayout>
                            </AuthProtected>
                        }
                    />
                ))}

                {/* Endereço que não existe.
                    O componente de erro já existia, mas só numa rota fixa —
                    sem esta curinga, digitar qualquer caminho desconhecido
                    deixava a tela em branco, sem nada que explicasse o que
                    houve nem como voltar. */}
                <Route path="*" element={<Error404 />} />
            </Routes>
        </React.Fragment>
    );
};

export default Index;
